import React from 'react';
import { EventRequestForm } from './EventRequestForm';
import { useLanguage } from '../contexts/LanguageContext';
import { eventOffers } from '../data/events';
import { formatPrice } from '../utils/format';
const eventImage = 'https://cdn.magicpatterns.com/patterns/generated-images/393ebb4d-1ab8-4406-8da9-9a68c75c60b8.jpg';
export function EventsSection() {
  const {
    t,
    l
  } = useLanguage();
  const e = t.events;
  return <section id="events" aria-labelledby="events-title" className="scroll-mt-16 bg-saddle py-20 text-cream lg:py-28" data-id="element-94" data-mp="8mf6dof28mmo">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:px-8" data-id="element-95" data-mp="3lri3ai7ujw5">
        <div className="lg:col-span-6" data-id="element-96" data-mp="3uski4b19wcz3">
          <h2 id="events-title" className="font-serif text-4xl font-bold md:text-5xl" data-id="element-97" data-mp="3pv2f119xsrz0">{e.title}</h2>
          <p className="mt-4 text-lg leading-relaxed text-cream/85" data-id="element-98" data-mp="2jeyqmj7xxzae">{e.intro}</p>
          <p className="mt-3 font-serif text-lg italic text-straw" data-id="element-99" data-mp="2jcm2tpfi4upf">{e.season}</p>

          <div className="mt-8 aspect-[16/10] overflow-hidden rounded-lg" data-id="element-100" data-mp="2eeklpa1mz5gl">
            <img src={eventImage} alt="" className="h-full w-full object-cover" loading="lazy" data-id="element-101" data-mp="rkfggnnaepvo" />
          </div>

          <ul className="mt-8 divide-y divide-cream/20 border-y border-cream/20" data-id="element-102" data-mp="whp3jwn7epgc">
            {eventOffers.map(offer => <li key={offer.id} className="flex items-start justify-between gap-6 py-5" data-id="element-103" data-mp="hnaqsdu8gca4">
                <div data-id="element-104" data-mp="mm4528hcg7bc">
                  <h3 className="font-serif text-xl font-bold" data-id="element-105" data-mp="8smkqlgu2qk9">{l(offer.title)}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-cream/90" data-id="element-106" data-mp="8qrzf61ngwfn">{l(offer.description)}</p>
                </div>
                <p className="shrink-0 whitespace-nowrap text-right" data-id="element-107" data-mp="3v0cs7113k5w4">
                  <span className="block text-xs text-cream/85" data-id="element-108" data-mp="3uy02u2t0et91">{e.from}</span>
                  <span className="font-serif text-2xl font-bold text-cream" data-id="element-109" data-mp="3tt6urxmwxjk">{formatPrice(offer.price, t.meta.locale)}</span>
                  {offer.unit && <span className="ml-1 text-sm text-cream/85" data-id="element-110" data-mp="3q0i0wwdeteaj">{l(offer.unit)}</span>}
                </p>
              </li>)}
          </ul>
        </div>

        <div className="lg:col-span-6 lg:pt-2" data-id="element-111" data-mp="1wk3xeaso0xim">
          <div className="lg:sticky lg:top-24" data-id="element-112" data-mp="1rr113uwi79yq">
            <EventRequestForm data-id="element-113" data-mp="1rp7taca5mjp5" />
          </div>
        </div>
      </div>
    </section>;
}